export default "__VITE_ASSET__DF8ZHEu3__"